import React from 'react';
import { Box, Button } from '@mui/material';
import { MonetizationOn } from '@mui/icons-material';
import { Chip } from 'cprime-foundational-components';
import TooltipWrapper from 'components/TooltipWrapper/TooltipWrapper';
import TypographyMarked from 'components/TypographyMarked/TypographyMarked';
import { formatDataValue } from 'utils/formatFns';
import { booleanToYN, generateTestId } from 'utils/general';
import { getChipSx } from '../utils/utils';
import { chipColorMap } from 'utils/colorMappers';

export const soldOrderFields = {
  nsoDealer: {
    label: 'NSO Dealer',
    getValue: (data) => ({
      dealerCode: data?.soldOrder?.soldOrderDealerCode,
      dealerName: data?.soldOrder?.soldOrderDealerName,
    }),
    formatValue: ({ dealerCode, dealerName }) => {
      const formattedCode = formatDataValue({ value: dealerCode });
      const formattedName = formatDataValue({ value: dealerName });
      return `${formattedCode} | ${formattedName}`;
    },
  },
  nsoFulfillmentType: {
    label: 'NSO Fulfillment Type',
    getValue: (data) => data?.soldOrder?.fulfillmentTypeDescription,
    formatValue: (value) => (value ? formatDataValue({ value }) : null),
  },
  soldOrderDate: {
    label: 'Sold Order Date',
    getValue: (data) => data?.soldOrder?.soldOrderCreationDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  soldOrderIndicator: {
    label: 'Sold Order',
    getValue: (data) => data?.soldOrder?.soldOrderIndicator,
    formatValue: (value, options = {}) => {
      if (!value) {
        return null;
      }

      return (
        <Button
          component="a"
          href="#national_sold_order"
          sx={{
            p: 0,
            m: 0,
          }}
        >
          <TooltipWrapper tooltipText="Sold Order">
            <Box display="flex" alignItems="center">
              <Chip
                data-testid={generateTestId(
                  'VehicleRecord',
                  'VehicleDetailsHeader',
                  'sold-order-chip',
                )}
                label={
                  options.isMobile ? (
                    ''
                  ) : (
                    <TypographyMarked
                      variant="label"
                      component="span"
                      value="Sold Order"
                      fieldId="vehicle-hero-sold-order"
                      searchContextValues={options.searchContextValues}
                      isPrint={options.isPrint}
                    />
                  )
                }
                icon={
                  options.isMobile ? <MonetizationOn color={chipColorMap.currentSaleText} /> : null
                }
                color={chipColorMap.currentSaleText}
                backgroundColor={chipColorMap.currentSaleBackground}
                sx={getChipSx(options)}
              />
            </Box>
          </TooltipWrapper>
        </Button>
      );
    },
  },
  soldOrderNumber: {
    label: 'Sold Order No.',
    getValue: (data) => data?.soldOrder?.soldOrderNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  soldOrderRequest: {
    label: 'Sold Order Request',
    getValue: (data) => data?.soldOrder?.soldOrderIndicator,
    formatValue: (value) => booleanToYN(value) || 'N/A',
    withCopyIcon: true,
  },
  soldOrderSubmittedDate: {
    label: 'Sold Order Submitted Date',
    getValue: (data) => data?.soldOrder?.soldOrderSubmittedDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
};
